import _ from "lodash";

const legalEntityMapper = {
  /**
   * Map array of legal entities objects
   * @param {Array} legalEntities
   * @return {Array}
   */
  mapLegalEntities: function (entities) {
    return entities.map((item) => {
      return this.mapLegalEntity(item);
    });
  },

  /**
   * Map physical entity object
   * @param {Object} physicalEntity
   * @return {Object}
   */
  mapLegalEntity: function (entity) {
    entity.initials = entity.firm_name.charAt(0).toUpperCase();

    return _.mapKeys(entity, (value, key) => _.camelCase(key));
  },
};

export default legalEntityMapper;
